const NoPage = () => {
  return <div className="alert alert-danger text-center" role="alert">
    Page not found!
  </div>;
};

export default NoPage;